import { render, staticRenderFns } from "./TitleRemovalBanner.vue?vue&type=template&id=6b6e3350&scoped=true"
import script from "./TitleRemovalBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./TitleRemovalBanner.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TitleRemovalBanner.vue?vue&type=style&index=0&id=6b6e3350&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6e3350",
  null
  
)

export default component.exports